<template>
    <div v-if="state.authority">
        <div :class="['index-wrap', state.className]" ref="indexWrap">
            <div class="index-wrap-left">
                <CompPro type="index" :actions="state.actions" />
                <template v-if="state.pro_info.status_code != -3">
                    <!-- 核心数据 -->
                    <div class="MainBox MainBox-index">
                        <div class="index-title">
                            <strong class="tit">核心数据</strong>
                            <div class="more" @click="routerGo('analysis')">查看更多</div>
                        </div>
                        <CompData :pro_id="state.pro_id" :pro_info="state.pro_info" />
                    </div>
                    <!-- 订单管理、售后管理 -->
                    <div class="index-order-box">
                        <div class="MainBox">
                            <div class="index-title">
                                <strong class="tit">订单管理</strong>
                                <div v-if="!state.isWds" class="more" @click="routerGo('deliver')">批量发货</div>
                                <div class="more" @click="routerGo('order')">查看更多</div>
                            </div>
                            <GridList width="132">
                                <div class="order-item">
                                    <strong :class="{'gray': state.orderInfo.total <= 0}">{{ state.orderInfo.total }}</strong>
                                    <span>全部</span>
                                </div>
                                <div class="order-item">
                                    <strong :class="{'gray': state.orderInfo.await_deliver <= 0}">{{ state.orderInfo.await_deliver }}</strong>
                                    <span>待发货</span>
                                </div>
                                <div class="order-item">
                                    <strong :class="{'gray': state.orderInfo.partial_deliver <= 0}">{{ state.orderInfo.partial_deliver }}</strong>
                                    <span>部分发货</span>
                                </div>
                                <div class="order-item">
                                    <strong :class="{'gray': state.orderInfo.deliver_on_time <= 0}">{{ state.orderInfo.deliver_on_time }}</strong>
                                    <span>逾期发货</span>
                                </div>
                                <div class="order-item">
                                    <strong :class="{'gray': state.orderInfo.delay_recv <= 0}">{{ state.orderInfo.delay_recv }}</strong>
                                    <span>延迟收货</span>
                                </div>
                                <div class="order-item">
                                    <strong :class="{'gray': state.orderInfo.bad_comment <= 0}">{{ state.orderInfo.bad_comment }}</strong>
                                    <span>差评</span>
                                </div>
                                <div class="order-item">
                                    <strong :class="{'gray': state.orderInfo.address_audit <= 0}">{{ state.orderInfo.address_audit }}</strong>
                                    <span>改地址申请</span>
                                </div>
                            </GridList>
                        </div>
                        <div v-if="!state.isWds" class="MainBox order-box">
                            <div class="index-title">
                                <strong class="tit">售后管理</strong>
                                <div class="more" @click="routerGo('after_sale')">查看更多</div>
                            </div>
                            <GridList width="132">
                                <div class="order-item">
                                    <strong :class="{'gray': state.refundInfo.total <= 0}">{{ state.refundInfo.total }}</strong>
                                    <span>全部</span>
                                </div>
                                <div class="order-item">
                                    <strong :class="{'gray': state.refundInfo.apply <= 0}">{{ state.refundInfo.apply }}</strong>
                                    <span>待审批</span>
                                </div>
                                <div class="order-item">
                                    <strong :class="{'gray': state.refundInfo.refunding <= 0}">{{ state.refundInfo.refunding }}</strong>
                                    <span>退款中</span>
                                </div>
                                <div class="order-item">
                                    <strong :class="{'gray': state.refundInfo.refund_success <= 0}">{{ state.refundInfo.refund_success }}</strong>
                                    <span>已完成退款</span>
                                </div>
                            </GridList>
                        </div>
                    </div>
                </template>
            </div>
            <div class="index-wrap-right">
                <div class="MainBox margin-b index-wrap-right-item">
                    <div class="index-title">
                        <strong class="tit">项目运营手机号</strong>
                    </div>
                    <div class="index-telephone">
                        <div>{{state.pro_info.telephone}}</div>
                        <span class="telephone-edit-btn" @click="dialogEditTelephoneVisible = true">修改</span>
                    </div>
                </div>
                <!-- 微打赏不显示 -->
                <template v-if="!state.isWds">
                    <!-- 摩点专属顾问、常用工具 -->
                    <!-- <div v-if="state.cpOperator && state.cpOperator.length" class="MainBox margin-b index-wrap-right-item">
                        <div class="index-title">
                            <strong class="tit">摩点专属顾问</strong>
                        </div>
                        <CompOperator :cpOperator="state.cpOperator"/>
                    </div> -->
                    <!-- 关联的创意 -->
                    <div 
                        v-if="state.pro_info && state.pro_info.idea_info && state.pro_info.idea_info.idea_id" 
                        class="MainBox margin-b index-wrap-right-item">
                        <div class="index-title">
                            <strong class="tit">关联的创意</strong>
                            <div class="more" @click="goIdea">
                                <span class="icon-eye icon"></span>
                                <span>创意预览</span>
                            </div>
                        </div>
                        <CompIdea :ideaInfo="state.ideaInfo" @goIdea="goIdea" />
                    </div>
                </template>
                <!-- 常用工具 -->
                <div v-if="!state.isTemp" class="MainBox margin-b index-wrap-right-item">
                    <div class="index-title">
                        <strong class="tit">常用工具</strong>
                    </div>
                    <CompTools
                        :pro_id="state.pro_id"
                        :pro_info="state.pro_info" />
                </div>
            </div>
        </div>
        <el-drawer 
            v-model="state.ideaDrawer" 
            title="创意预览"
            size="400px">
            <div class="idea-drawer">
                <div class="img" style="width: 140px; height: 140px; overflow: hidden;">
                    <div class="qrCodeUrl" ref="qrCodeUrl"></div>
                </div>
                <p class="qr-tips">微信扫码查看“创意详情”</p>
            </div>
            <template #footer>
                <el-button type="primary" @click="state.ideaDrawer=false">确认</el-button>
            </template>
        </el-drawer>

        <!-- 修改项目运营手机号 -->
        <el-dialog 
            v-model="dialogEditTelephoneVisible"
            :show-close="false"
            width="690"
            class="edit-telephone-dialog"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            @open="state.name=state.pro_info.telephone">
            <template #header>
                <strong class="tit">项目者联系方式</strong>
            </template>
            <div class="edit-telephone-dialog-content">
                <img class="close" src="~@assets/images/close_2.png" @click="dialogEditTelephoneVisible=false" />
                <div class="des">仅用于摩点工作人员联系你，不会展示在项目页中</div>
                <el-form-item size="large">
                    <template #label>
                        <div class="label">
                            <span>项目运营手机号</span>
                            <span class="red">*</span>
                        </div>
                    </template>
                    <el-input v-model="state.telephone" />
                </el-form-item>
                <div class="tips">将用于接收本项目相关的短信通知，可修改，如：项目审核进度、款项结算进度、订单售后及客诉工单进度等</div>
                <div class="dialog-btn-box">
                    <div class="dialog-btn cancel" @click="dialogEditTelephoneVisible=false">取消</div>
                    <div class="dialog-btn save" @click="saveEditTelephone">保存</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script setup>
import domain from '@/service/domain'

import { reactive, computed, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from 'vuex'
import { onUnmounted, watch } from "@vue/runtime-core";
import { ElMessage } from "element-plus";

import CompPro from "@@/common/proInfo.vue";
import CompData from "@@/index/data.vue"
import GridList from "@@/common/gridList.vue"; 
// import CompOperator from '@@/index/Operator.vue'
import CompTools from '@@/index/Tools.vue'
import CompIdea from '@@/index/Idea.vue'
import { getMenu, menuRoute } from '@/utils/mapMenu'

import { getOrderStatistics, getIdeaInfoByProId, getRefundStatistics, getProQuickActions, updateProTelephone } from "@/api/index"

const state = reactive({
    orderInfo: {}, // 订单管理数据
    refundInfo: {}, // 售后管理数据
    cpOperator: [], // 负责cp的运营和商务信息
    ideaInfo: {}, // 创意详情
    className: '',
    observer: null,
    dom: null,
    actions: [],
    dialogEditTelephoneVisible: false,
    telephone: ''
})
const route = useRoute();
const router = useRouter();
const store = useStore()
state.pro_id = computed(() => {
    return store.state.project.proInfo.id || ''
})

state.pro_info = computed(() => {
    return store.state.project.proInfo.info || {}
})
state.authority = computed(() => {
    return store.state.project.authority || false
})
// 是否是准备中
state.isTemp = computed(() => {
    return route.path.includes('temp') || false
})
state.isWds = computed(() => {
    return state.pro_info.pro_class == '201'
})
const refresh = async () => {
    getActions()
    // 准备中不请求其他接口
    if (state.pro_info.status_code != -3) {
        getOrderInfo()
        if (!state.isWds) {
            getRefundInfo()
        }
    }
    // getOperator()
}
// 获取订单管理数据
const getOrderInfo = () => {
    getOrderStatistics({
        pro_id: state.pro_id
    }).then(res => {
        if (res.status == 0) {
            state.orderInfo = res.data
        }
    })
}
// 获取售后管理数据
const getRefundInfo = () => {
    getRefundStatistics({
        pro_id: state.pro_id
    }).then(res => {
        if (res.status == 0) {
            state.refundInfo = res.data
        }
    })
}
// 获取负责cp的运营和商务信息
// const getOperator = () => {
//     getCpOperator({
//         pro_id: state.pro_id
//     }).then(res => {
//         if(res.status == 0) {
//             state.cpOperator = res.data
//         }
//     })
// }
const routerGo = (route) => {
    if (route) {
        menuRoute(route, route, state.pro_id, state.pro_info)
    } else {
        router.push(`/project_manage/${route}/${state.pro_id}`)
    }
}
// 获取关联的创意详情
const getIdeaInfo = () => {
    getIdeaInfoByProId({
        pro_id: state.pro_id
    }).then(res => {
        if (res.status == 0 && res.data) {
            state.ideaInfo = res.data
        }
    })
}
// 获取操作按钮
const getActions = () => {
    let pro_info =store.state.project.proInfo.info
    // 如果是动物救助
    if (pro_info.pro_class == '201') {
        let menu = getMenu('wdsActions')
        if (menu[pro_info.status_code] && menu[pro_info.status_code].length) {
            state.actions = menu[pro_info.status_code]
        } else {
            state.actions = [{action_name: "项目管理", action_type: "goOld"}]
        }
    } else {
        // 准备中
        if (pro_info.status_code == -3) {
            state.actions = [{
                action_name: "编辑项目资料", 
                action_type: "edit"
            },{
                action_name: "删除项目", 
                action_type: "delete"
            }]
        } else {
            getProQuickActions({
                pro_id: state.pro_id
            }).then(res => {
                if(res.status == 0) {
                    state.actions = res.data
                }
            })
        }
    }
}
watch(() => {[state.pro_info]}, () => {
    if (state.pro_info && state.pro_info.idea_info && state.pro_info.idea_info.idea_id ) {
        getIdeaInfo()
    }
}, { deep: true, immediate: true })
watch(() => {[route.params.id]}, () => {
    if (route.fullPath.indexOf("/project_manage/index") == 0) {
        refresh()
    }
}, { deep: true, immediate: true })

// 视图变化 -- start
const indexWrap = ref(null)
watch(() => {[state.authority, indexWrap.value]}, () => {
    if (state.authority && indexWrap.value) {
        state.dom = indexWrap.value
        state.observer = new ResizeObserver(entries => {
            for (const entry of entries) {
                switch(entry.target){
                    case state.dom:
                        view(state.dom)
                    break
                }
            }
        })
        state.observer.observe(state.dom);
    }
}, { deep: true, immediate: true })
const view = (dom) => {
    if (dom.clientWidth < 1280) {
        state.className = 'index-wrap-min'
    } else {
        state.className = 'index-wrap-big'
    }
}
onUnmounted(() => {
    if (state.observer) {
        state.observer.unobserve(state.dom)
    }
})
// 视图变化 -- end

// 创意预览
const goIdea = () => {
    let url = domain.wap + `/idea/${state.ideaInfo.idea_id}`
    window.open(url)
}

const dialogEditTelephoneVisible = ref(false)
// 修改项目运营手机号
const saveEditTelephone = () => {
    if (!state.telephone) {
        ElMessage({
            type: 'warning',
            customClass: 'info-customize',
            message: '请输入项目运营手机号',
        });
    } else if (state.telephone && state.telephone != state.pro_info.telephone) {
        updateProTelephone({
            pro_id: state.pro_id,
            telephone: state.telephone
        }).then(res => {
            if (res.status == 0 && res.data) {
                ElMessage({
                    type: 'info',
                    customClass: 'info-customize',
                    message: '修改成功',
                });
                dialogEditTelephoneVisible.value = false
            } else {
                ElMessage({
                    type: 'warning',
                    customClass: 'info-customize',
                    message: '修改失败',
                });
            }
        })
    } else {
        dialogEditTelephoneVisible.value = false
    }
}

</script>

<style lang="scss" scoped>
.index-wrap {
    .more {
        padding: 0 6px;
        height: 28px;
        background: #EBFBF8;
        border-radius: 4px;
        color: #00C4A1;
        text-align: center;
        line-height: 28px;
        cursor: pointer;
        margin-left: 10px;
        display: flex;
        align-items: center;
        .icon {
            margin-right: 2px;
        }
    }
    .index-title {
        display: flex;
        justify-content: space-between;
        .tit {
            font-size: 20px;
            margin-right: auto;
        }
    }
    .MainBox-index {
        padding-bottom: 0;
    }
    .index-order-box {
        margin-top: 20px;
        display: flex;
        .MainBox {
            flex: 1;
            &.order-box {
                margin-left: 20px;
            }
        }
        .order-item {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            line-height: 1;
            height: 86px;
            strong {
                font-size: 18px;
                padding-bottom: 14px;
                &.gray {
                    color: #B1B1B1;
                }
            }
        }
    }
    .margin-b {
        margin-bottom: 20px;
    }
}
// 创意预览抽屉
.idea-drawer {
    .img {
        margin: 36px auto 6px;
    }
    .qr-tips {
        color: #7F7F7F;
        text-align: center;
    }
}
.index-wrap-min {
    display: block;
    .index-wrap-right {
        display: flex;
        flex-wrap: wrap;
        margin-top: 20px;
        justify-content: space-between;
        &-item {
            width: calc((100% - 20px)/2);
        }
    }
}
.index-wrap-big {
    display: flex;
    .index-wrap-left {
        flex: 1;
        min-width: 820px;
    }
    .index-wrap-right {
        width: 400px;
        margin-left: 20px;
    } 
}

// 项目运营手机号
.index-telephone {
    background-color: #F8F8F8;
    border-radius: 6px;
    display: flex;
    justify-content: space-between;
    height: 48px;
    padding: 0 10px;
    line-height: 48px;
    margin-top: 20px;
    font-size: 16px;
    .telephone-edit-btn {
        color: #00C4A1;
        cursor: pointer;
    }
}
.edit-telephone-dialog {
    .tit {
        padding: 4px 14px;
        font-size: 24px;
        color: #222C37;
    }
    .edit-telephone-dialog-content {
        padding: 20px 0 4px;
        margin: 0 14px;
        border-top: 1px solid #E8E8E8;
        font-size: 16px;
        position: relative;
        .des {
            color: #222C37;
            padding-bottom: 24px;
        }
        .tips {
            font-size: 14px;
            line-height: 24.5px;
        }
        .label {
            color: #222C37;
            font-size: 16px;
            .red {
                color: #FF4A4A;
            }
        }
        .close {
            width: 16px;
            height: 16px;
            cursor: pointer;
            position: absolute;
            top: -54px;
            right: -56px;
        }
        .dialog-btn-box {
            padding-top: 20px;
            display: flex;
            justify-content: flex-end;
            .dialog-btn {
                width: 120px;
                height: 40px;
                font-size: 16px;
                text-align: center;
                line-height: 40px;
                &.cancel {
                    border: 1px solid #BCBFC3;
                    color: #7A8087;
                }
                &.save {
                    background: #00C4A1;
                    color: #FFFFFF;
                    margin-left: 20px;
                }
            }
        }
    }
}
</style>
